import { passCodes } from '../passCodes';
import audio from '../../../../assets/audio/kids-tracks/Text10.mp3';

export const step11sign = {
    id: 11,
    title: 'Značka',
    taskText: `
        <p>
            Tak už jsme u ní, co to ale je za značku, nevíš? Docela by mě zajímalo, co tady máme dělat.
        </p>
    `,
    cipher: {
        text: `
            <p>
                Co je to za značku?
            </p>
            <ol type="a">
                <li>Zákaz jízdy na kole</li>
                <li>Zákaz zastavení</li>
                <li>Pozor divoká zvěř</li>
            </ol>`,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[2],
    additionalInfo: 'Odpovědí je písmeno a/b/c',
    points: true,
    audio: audio,
    hints: [
        {
            text: 'Jde o značku "Zákaz zastavení", odpověď je b',
        },
    ],
};
